import { JsonApiQuery } from '@nx-icilalune/data/access';
import {
  BusinessUnitTerm,
  Client,
  News,
  Page,
  PageTemplateTerm,
  ParagraphContentLinks,
  Project,
} from '@nx-icilalune/data/icilalune/types';
import {
  allParagraphIncludes,
  paragraphLinkedContentIncludes,
} from './icilalune.queries';
import { ImageMedia } from '@nx-icilalune/drupal-types';

const pageHomeSectionIncludes = [
  'thumbnail',
  'layout_template',
  ...paragraphLinkedContentIncludes,
];

const pageForListIncludes = ['thumbnail', 'layout_template'];

const pageDetailIncludes = [
  ...pageHomeSectionIncludes,
  'layout_template',
  ...allParagraphIncludes,
  'media',
];

export const pageHomeSectionQuery: JsonApiQuery = {
  queryId: 'pageHomeSection',
  type: Page.type,
  fields: {
    [Page.type]: [
      'title',
      'path',
      'langcode',
      'thumbnail',
      'layout_template',
      'paragraphs',
      'body',
      'summary',
    ],
    [PageTemplateTerm.type]: ['name'],
    [BusinessUnitTerm.type]: ['name'],
    [ImageMedia.type]: ['fileRef', 'langcode'],
    [Project.type]: [
      'title',
      'client',
      'thumbnail',
      'path',
      'langcode',
      'business_unit',
    ],
    [News.type]: ['title', 'thumbnail', 'path', 'langcode'],
    [ParagraphContentLinks.type]: ['langcode', 'linked_content'],
    [Client.type]: ['title', 'langcode', 'path'],
  },
  include: pageHomeSectionIncludes,
  relationAttributeEnhancers: [
    'thumbnail.fileRef',
    'business_unit.name',
    'layout_template.name',
  ],
  errorMessage: 'errors.pages.section',
  filters: {
    isPublished: '1',
  },
};

export const pageForListQuery: JsonApiQuery = {
  queryId: 'pageForList',
  type: Page.type,
  include: pageForListIncludes,
  relationAttributeEnhancers: ['layout_template.name'],
  filters: {
    isPublished: '1',
  },
};

export const pageDetailQuery: JsonApiQuery = {
  queryId: 'pageDetail',
  type: Page.type,
  include: pageDetailIncludes,
  relationAttributeEnhancers: [
    'layout_template.name',
    'thumbnail.fileRef',
    'media.fileRef',
  ],
  filters: {
    isPublished: '1',
  },
};
